"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionModelFieldSelectList = exports.ModelMutatorSelectList = void 0;
const core_api_1 = require("@ikegps/core-api");
const collection_field_1 = require("../collection.field");
class ModelMutatorSelectList extends collection_field_1.ModelMutator {
    manual(newText) {
        const option = this.field.schema.findOption(newText);
        if (option == null) {
            this.state.setFieldValue(this.field.id, null);
            return;
        }
        this.state.setFieldValue(this.field.id, option.value);
    }
    copy(from) {
        if (!from.hasValue()) {
            this.manual(null);
            return true;
        }
        const value = from.value;
        if (this.field.schema.findOption(value) != null) {
            this.manual(value);
            return true;
        }
        return false;
    }
}
exports.ModelMutatorSelectList = ModelMutatorSelectList;
class CollectionModelFieldSelectList extends collection_field_1.CollectionModelField {
    static isSelectListField(f) {
        return f.schema.type === CollectionModelFieldSelectList.TYPE;
    }
    get Mutator() {
        if (this._Mutator == null) {
            this._Mutator = new ModelMutatorSelectList(this);
        }
        return this._Mutator;
    }
    get value() {
        return this.stateValue || this.schema.unselectedValue;
    }
    get displayValue() {
        const opt = this.schema.findOption(this.value);
        if (opt != null) {
            return opt.text;
        }
        return null;
    }
    get color() {
        const opt = this.schema.findOption(this.value);
        if (opt === null || opt === void 0 ? void 0 : opt.color) {
            return opt.color;
        }
        return null;
    }
    hasValue() {
        return this.value !== this.schema.unselectedValue;
    }
}
exports.CollectionModelFieldSelectList = CollectionModelFieldSelectList;
CollectionModelFieldSelectList.TYPE = core_api_1.IkeFieldType.SELECT_LIST;
//# sourceMappingURL=select.list.field.js.map